import React from 'react';
import Pill from 'components/Pill';
import colors from 'config/colors';
import './timesheet-status-pill.scss';

const StatusPill = ({ responsive, label, ...props }) => {
  if (!responsive) return <Pill {...props} label={label} />;

  return (
    <span className="timesheet-status-pill" title={label}>
      <Pill {...props} label={label} />
    </span>
  );
};

const TimesheetStatusPill = ({ timesheet, responsive = false }) => {
  const { paidAt: paid } = timesheet;
  if (timesheet.isArchived === true || timesheet.status === 'archived') { return <StatusPill responsive={responsive} style={{ width: 150, backgroundColor: '#526C80', color: colors.white }} label="Archived" />; }
  if (timesheet.status === 'approved' && !paid) { return <StatusPill responsive={responsive} style={{ width: 150 }} label="Approved" type="positive" />; }
  if (timesheet.status === 'rejected') { return <StatusPill responsive={responsive} style={{ width: 150, backgroundColor: '#A65353', borderColor: '#A65353', color: colors.white }} label="Rejected" />; }
  if (timesheet.status === 'approved' && paid) { return <StatusPill responsive={responsive} style={{ width: 150 }} label="Paid" type="warning" />; }
  if (timesheet.timesheetIsLocked) { return <StatusPill responsive={responsive} style={{ width: 150 }} label="Locked" type="danger" />; }
  if (timesheet.status === 'pending-approval') { return <StatusPill responsive={responsive} style={{ width: 150 }} label="Pending Approval" type="positive" outline />; }
  return <StatusPill responsive={responsive} label="Awaiting Submission" style={{ backgroundColor: colors.dagny.backgroundLight4, color: colors.white, width: 150 }} outline />;
};

export default TimesheetStatusPill;
